import React from 'react';
import { Box, Link, Typography } from '@availity/element';

// eslint-disable-next-line react/prop-types
const EssentialsUserAgreement = () => (
  <Box px={2}>
    <Box sx={{ textAlign: 'center' }}>
      <Typography variant="h1" mt={1} mb={2}>
        Availity User Agreement
      </Typography>
    </Box>
    <Typography variant="agreement" gutterBottom>
      <p>
        <span>
          This Availity User Agreement &#40;the &quot;Agreement&quot;&#41; is a legal agreement by and between Availity,
          L.L.C. on behalf of itself and its affiliates &#40;&quot;We&quot;, &quot;Us&quot;, or &quot;Our&quot;&#41; and
          you in your individual capacity and as a designee of your Organization &#40;&quot;You&quot;, &quot;Your&quot;,
          or &quot;User&quot;&#41;, for use of products and services &#40;the &quot;Products and Services&quot;&#41;
          that may be available via Availity&apos;s secure websites &#40;&quot;Site&quot;&#41;. We and You are sometimes
          hereinafter referred to individually as the &quot;Party&quot; or collectively as the &quot;Parties&quot;.
          Please read this Agreement carefully. To confirm Your understanding and acceptance of this Agreement, You MUST
          scroll down to the end of this page and click &quot;I Agree.&quot; If You decline this Agreement, You may not
          use or access the Products and Services.
        </span>
      </p>
      <p>
        <span>
          THIS AGREEMENT CONTAINS VERY IMPORTANT INFORMATION REGARDING YOUR RIGHTS AND OBLIGATIONS, AS WELL AS
          CONDITIONS, LIMITATIONS, AND EXCLUSIONS THAT APPLY TO YOUR USE OF AND ACCESS TO THE PRODUCTS AND SERVICES. BY
          USING AND ACCESSING THE SERVICES VIA THIS SITE, YOU AFFIRM THAT YOU ARE OF LEGAL AGE TO ENTER INTO THIS
          AGREEMENT, YOU ACCEPT AND ARE BOUND BY THESE TERMS AND CONDITIONS, AND ACKNOWLEDGE AND UNDERSTAND THAT THESE
          TERMS MAY BE UPDATED OR MODIFIED AT ANY TIME, IN OUR SOLE DISCRETION. UPDATES AND MODIFICATIONS TO THE TERMS
          OF THIS AGREEMENT ARE EFFECTIVE IMMEDIATELY UPON BEING POSTED TO THE SITE. YOU MAY NOT USE OR ACCESS THE
          SERVICES, THIS SITE OR ANY OF ITS CONTENT IF YOU ARE PROHIBITED FROM DOING SO BY APPLICABLE LAW.
        </span>
      </p>
      <p>
        <strong>TERMS AND CONDITIONS</strong>
      </p>
      <p>
        <span>
          <strong>1. Definitions</strong>
        </span>
      </p>
      <ol type="a">
        <li>
          &quot;Administrator&quot; is the person&#40;s&#41; who has legal authority to sign agreements on behalf of
          Your Organization, and who authorized Your use of and access to the Services on behalf of Your Organization.
        </li>
        <li>
          &quot;Content&quot; means all data, features, functionality, self-service functions, materials, text,
          graphics, images, displays, files, software, sound recordings, audiovisual works, images, user guides,
          operating manuals, policies, blogs, news, reports, and other materials provided by Us or made available or
          displayed via the Site, and the design, arrangement, and compilation of the Site, in each case, as may be
          modified from time to time by Us. Content excludes any content provided by payers through Payer Spaces or
          other sites or applications linked from or to the Site.
        </li>
        <li>
          &quot;Login Credentials&quot; means the unique User identification and password combination required to gain
          access to the Services, including any and all security measures required prior to gaining access to the
          Services.
        </li>
        <li>
          &quot;Organization&quot; means the organization, entity, or company that qualifies as either a &quot;Covered
          Entity&quot; or &quot;Business Associate&quot; as defined in 45 CFR §160.103, and on whose behalf You are
          granted access to the Services.
        </li>
        <li>
          &quot;Services Agreement&quot; or means the Agreement between Us and Your Organization governing the use of
          and access to the Products and Services.
        </li>
        <li>
          &quot;Protected Health Information&quot; or &quot;PHI&quot; means individual identifiable information as
          defined in the Health Insurance Portability and Accountability Act of 1996 and the regulations promulgated
          thereunder &#40;&quot;HIPAA&quot;&#41;.
        </li>
        <li>
          &quot;Services&quot; means the Products and Services, and all related Content made available to You through
          the Site, and includes any updates, upgrades, enhancements, improvements, or modifications that We make
          available to You as part of the Services.
        </li>
      </ol>

      <p>
        <span>
          <strong>2. Your Use of the Services.</strong> Subject to Your Organization&apos;s compliance with the terms
          and conditions of the Services Agreement, We hereby grant You a limited, revocable, non-exclusive,
          non-transferable license solely to access and use the Services for the permitted uses described in this
          Agreement. You agree to use the Services in compliance with the terms of this Agreement, all policies and
          terms specified by Us from time to time and made available to You, and all applicable laws, rules, and
          regulations. You may access and use the Services for Your internal legitimate business purposes only. Any
          access or use of the Services for other purposes is strictly prohibited.
        </span>
      </p>
      <p>
        <span>By using the Services, You represent that:</span>
      </p>
      <ol type="a">
        <li>
          You have not been previously convicted of a criminal offense related to healthcare or been listed as debarred
          excluded or otherwise ineligible for participation in a federal health care program or public government
          contract. You will immediately notify Us if You become aware that You have been excluded or are otherwise
          ineligible to participate in a federal health care program or public government contract and will immediately
          discontinue access to the Services for any affected entities or individuals.
        </li>
        <li>You are at least 18 years of age.</li>
      </ol>

      <p>
        <span>
          <strong>3. Restrictions On Use. </strong> You will not:
        </span>
      </p>
      <ol type="a">
        <li>provide any person access to the Services or Content;</li>
        <li>
          sell, resell, rent, license, sublicense, distribute lease, copy, frame, or mirror any part of the Services or
          Content;
        </li>
        <li>
          use the Services to store or transmit false, fraudulent, infringing, libelous, or otherwise unlawful or
          tortious material, or to store or transmit material in violation of third-party privacy rights;
        </li>
        <li>
          use the Services to store or transmit viruses, worms, time bombs, Trojan horses, and other harmful or
          malicious code, files, scripts, agents, or programs;
        </li>
        <li>
          interfere with or disrupt Our servers or networks (including, but not limited to, by means of the transmission
          of any virus, worm, Trojan horse, or other items of a destructive or harmful nature), or otherwise interfere
          with the integrity or performance of the Services or third-party data contained therein;
        </li>
        <li>
          use the Service or Content in a manner contrary to how the Service or Content are intended or designed, or
          attempt to gain access to the Services or the related systems or networks through unauthorized methods, or
          otherwise violate, tamper with or circumvent the security of any computer network, software, passwords,
          encryption codes, technological protection measures, including but not limited to accessing the Services in
          any manner not contemplated or permitted under this Agreement, or to enable others to do so;
        </li>
        <li>
          create derivate works based on the Services or Content and/or reverse engineer, disassemble, decompile, decode
          or otherwise attempt to derive or gain access to the source code of the Services or any part thereof;
        </li>
        <li>access the Services or Content in order to build a competitive product or service;</li>
        <li>
          use the Services or Content in a manner which may violate the laws and regulations of the United States or any
          other nation, or the laws and regulations of any state, city, province, or other jurisdiction;
        </li>
        <li>
          transmit any information using the Services without proper consent, authorization, or permission where
          required;
        </li>
        <li>copy any features, functions, or graphics of the Services or Content;</li>
        <li>submit any data that is subject to the European Union Data Protection Regulation 2016/679;</li>
        <li>
          submit eligibility and benefits transactions or otherwise use or access the Services or Content for the
          purpose of insurance discovery practices;
        </li>
        <li>
          use bots, technology, or methods that are intended to obtain information from the Services in a manner that is
          not intended by the Services and not for Your Organization&apos;s legitimate business purposes, commonly
          referred to as &quot;screen scraping,&quot; &quot;data scraping,&quot; &quot;web scraping,&quot; &quot;web
          emulation,&quot; or &quot;web bots&quot; &#40;collectively, &quot;Scraping Methods&quot;&#41; when accessing
          or using the Services, including but not limited to, when You submit medical transactions or other information
          or data through the Services. In the event that You use any of the Scraping Methods, We may utilize technical
          measures to prevent such usage and may, in Our sole and absolute discretion, suspend or terminate the
          connection. In addition, We may take direct legal action against You to the fullest extent permitted by law
          for use of any such Scraping Methods;
        </li>
        <li>
          submit transactions in a manner that We, in Our sole and absolute discretion, deem to be excessive or abusive.
          We will monitor Your usage and notify You and/or Your Organization if We determine Your use to be excessive or
          abusive. To the extent the parties do not reach a resolution of the issue within thirty &#40;30&#41; days of
          Our notice to You and/or Your Organization, We may utilize technical measures to prevent such usage and/or
          suspend or terminate You and Your Organization&apos;s use of and access to the Services.
        </li>
      </ol>

      <p>
        <span>
          <strong>4. Registration, Access, and Security.</strong>
        </span>
      </p>
      <ol type="a">
        <li>
          You are permitted to access the Services as a designated authorized user on behalf of Your Organization. You
          may only access the Services using the unique Login Credentials assigned to You.
        </li>
        <li>You will not allow any other person to use Your Login Credentials to access the Services.</li>
        <li>The Administrator may disable Your access to the Services at any time, in their sole discretion.</li>
        <li>
          Any attempt to obtain unauthorized access, or to exceed authorized access, to the Services and Content will be
          considered a trespass and computer fraud and abuse, punishable under state and federal laws.
        </li>
        <li>
          You acknowledge and agree that You and Your Organization will be fully liable for any and all charges,
          damages, or losses that may be incurred or suffered as a result of the acts and omissions of any third party
          that accesses the Services through use of Your Login Credentials, as if such acts and omissions were Your own.
        </li>
        <li>
          We are not and will not be liable for any harm arising from or relating to the theft of Your Login
          Credentials, Your disclosure of Your User ID or password or the use of Your User ID or password by another
          person or entity.
        </li>
        <li>
          You will maintain the strict confidentiality of the PHI You access through the Site and will maintain the
          security of all PHI and otherwise treat PHI in accordance with all requirements of federal, state and local
          laws, rules and regulations.
        </li>
        <li>
          Internet connectivity is required for You to access the Services. You are solely responsible, at Your own
          expense, to ensure that You have Internet access, and compatible hardware, and software necessary to access
          the Services.
        </li>
      </ol>

      <p>
        <span>
          <strong>5. Additional Terms and Conditions.</strong>
        </span>
      </p>
      <p>
        <span>
          During the period in which You are provided with authorized access to the Services, Our information, and
          information of Our subsidiaries and affiliates, You agree that:
        </span>
      </p>
      <ol type="a">
        <li>
          We may deny You access to the Services, Site, and/or Our information systems at any time, with or without
          cause.
        </li>
        <li>
          We reserve the right to access, read, copy, delete, and disclose information on Our systems and equipment. We
          reserve the right to inspect any and all files stored or transmitted to Our equipment.
        </li>
        <li>
          You shall not use Our Internet facilities and computing resources in a manner which may violate the laws and
          regulations of the United States or any other nation, or the laws and regulations of any State, City,
          Province, or other jurisdiction in any manner.
        </li>
        <li>
          You shall maintain in strictest confidence and shall not use or disclose any of Our information or Our managed
          and/or contracted entities, including, but not limited to, insured, plan, member, client, patient, enrollee,
          claim, or medical information or any information of Our mainframe or computing environment.
        </li>
        <li>
          Regarding Confidential Information made available to You through the Site, You may print a copy of any
          clinical information accessed only if You are authorized by a physician or other health care provider to do
          so, and only for the purpose of providing medical treatment to the subject patient of such health record
          information. You may not reproduce or distribute any text or graphics of the Site to others, or copy the
          information on Your own server, or link to the Site, without Our prior written permission. You may only use
          and access Confidential Information and any PHI made available to You solely for the legitimate purpose for
          which Your Administrator granted You access.
        </li>
        <li>
          If You become aware of or suspects fraudulent activity or any other activity that threatens the security of
          Our information systems, You must immediately report the activity to Us.
        </li>
        <li>
          Through Your use of the Services, payers, labs, and other health care intermediaries
          &#40;&quot;Intermediaries&quot;&#41; may make certain PHI available to You through the Site. Such PHI is
          provided to You only as a secondary source of information, and may not be complete and may contain errors.
          Before using any such information, You are responsible to verify its accuracy. We are only acting as a
          connector between You and the providers of such information made available to You, and We are not responsible
          for the content of the PHI.
        </li>
        <li>
          You will abide by any additional requirements of which You are notified and accept while on the Site with
          respect to PHI You access, and You will hold Us and any Intermediaries harmless from, and indemnify and defend
          Us and any Intermediaries against, any and all losses, damages, claims, expenses, and costs incurred, as a
          result of Your use of the PHI or violations of the terms of this Agreement. Intermediaries that provide PHI to
          You are intended third party beneficiaries under this Agreement, and shall have the right to enforce the
          terms, of this Section.
        </li>
      </ol>

      <p>
        <span>
          <strong>6. Medicaid Eligibility Transactions. </strong>To the extent applicable, You agree to comply with the
          Medicare Medicaid terms and conditions available at{' '}
          <Link
            href="https://www.availity.com/~/media/files/misc/Additional%20Medicaid%20Third%20Party%20Terms%20and%20Conditions%202023"
            target="_blank"
            loadApp={false}
          >
            Medicaid Terms.
          </Link>{' '}
          You agree that, with respect to Medicaid eligibility transactions: &#40;a&#41; access to eligibility
          information is restricted to the sole purpose of verification of Medicaid eligibility where the recipient has
          requested Medicaid payment for medical services; &#40;b&#41; verification of eligibility under the system is
          not a guarantee of payment and the records as to the recipient&apos;s eligibility status will be the final
          authority; and &#40;c&#41; You agree to abide by applicable federal and state laws regarding confidentiality
          of information.
        </span>
      </p>
      <p>
        <span>
          <strong>7. Confidentiality. </strong>
          Each Party &#40;as &quot;Receiving Party&quot;&#41; acknowledges and understands that in connection with this
          Agreement, the other party &#40;as “Disclosing Party”&#41; may share confidential or proprietary information,
          including without limitation terms and conditions of this Agreement, trade secrets, technology, software,
          information pertaining to business operations and strategies, pricing, and marketing, whether in oral,
          electronic, or written form, which the Receiving Party knows or should know by the nature of the information
          or its disclosure, is proprietary or confidential to the Disclosing Party &#40;&quot;Confidential
          Information&quot;&#41;. Confidential Information will not include information that: &#40;a&#41; is already
          known to the Receiving Party without restriction on use or disclosure prior to receipt of such information
          from the Disclosing Party; &#40;b&#41; is or becomes generally known by the public other than by breach of
          this Agreement by, or other wrongful act of, the Receiving Party; &#40;c&#41; is developed by the Receiving
          Party independently of, and without reference to, any Confidential Information of the Disclosing Party; or
          &#40;d&#41; is received by the Receiving Party from a third party who is not under any obligation to the
          Disclosing Party to maintain the confidentiality of such information. The Receiving Party will use the
          Confidential Information of the Disclosing Party only for the purpose of performing its obligations under this
          Agreement. The Receiving Party agrees not to disclose or otherwise make available Confidential Information of
          the Disclosing Party to any third party without the prior written consent of the Disclosing Party; provided,
          however, that the Receiving Party may disclose the Confidential Information of the Disclosing Party to its
          officers, employees, consultants and advisors who have a &quot;need to know&quot; and who are themselves bound
          by nondisclosure obligations at least as restrictive as those set forth in this Agreement. If the Receiving
          Party becomes legally compelled to disclose any Confidential Information, the Receiving Party will use
          commercially reasonable efforts to provide prompt written notice of such requirement, if legally permissible,
          so that the Disclosing Party may seek, at its sole cost and expense, a protective order or other remedy. At
          the termination of Your access or in the event the Services Agreement is terminated, in Your individual
          capacity, You agree to turn-over to Your Organization all documents or other materials furnished to, or
          accessed by You constituting Confidential Materials, without retaining any copies thereof.
        </span>
      </p>
      <p>
        <span>
          <strong>8. Intellectual Property. </strong> You acknowledge and agree that the Services and Content are
          protected by copyrights, trademarks, trade secrets, patents, or other proprietary rights, and that these
          rights are valid and protected in all forms, media, and technologies existing now and hereafter developed. You
          acknowledge and agree that We &#40;or payers or other third parties providing content for the Services&#41;
          exclusively own all rights, titles and interests in and to the Services, Content, and all intellectual
          property rights therein, and that the Services and Content will remain the property of Us and our licensors.
          You agree to comply with all applicable intellectual property laws and You will not encumber any interest in,
          or assert any rights to the Services or Content. You may print copies of the Content for Your legitimate
          internal business purposes only, but You may not modify, distribute, license, sublicense, transmit, create
          derivative works based on, link to, reproduce, or participate in the sale, transfer, or distribution of the
          Services or Content, in whole or in part, without prior written permission of Us. All rights not expressly
          granted in this Agreement are reserved to Us. No other rights or licenses are conveyed or intended by this
          Agreement.
        </span>
      </p>
      <p>
        <span>
          <strong>9. Data.</strong>
        </span>
      </p>
      <ol type="a">
        <li>
          <strong>Third Party Data.</strong> We are not responsible for the accuracy, quality, integrity, and legality
          of the data, including PHI, from third party sources that are made available to You in connection with the
          Services.
        </li>
        <li>
          In the event You provide Us with any suggestions, enhancement requests, recommendations, or other feedback
          relating to the Services &#40;collectively, &quot;Feedback&quot;&#41;, You grant Us a royalty-free, worldwide,
          transferable, sublicenseable, irrevocable, perpetual license to use or incorporate into the Services any such
          Feedback.
        </li>
      </ol>
      <p>
        <span>
          <strong>10. User Contributions.</strong> The Services may contain certain interactive features that allow You
          to post, submit, publish, display, provide, or transmit &#40;collectively, &quot;Post&quot;&#41; content or
          materials &#40;collectively, “User Contributions”&#41; on or through the Services. Any User Contributions You
          Post to the Services will be considered non-confidential and non-proprietary. By Posting any User
          Contributions, You grant Us, and Our affiliates, vendors, suppliers, licensors and service providers
          &#40;collectively, &quot;Related Entities&quot;&#41;, the right to use, reproduce, modify, perform, display,
          distribute, and otherwise disclose to third parties any User Contributions for any purpose. You represent and
          warrant that: &#40;a&#41; all User Contributions comply with the terms of this Agreement; &#40;b&#41; User
          Contributions do not infringe any third party rights; &#40;c&#41; You own or control all rights in and to User
          Contributions and have the right to grant the license granted above to Us and Our Related Entities; and
          &#40;d&#41; User Contributions may not contain any PHI. You understand and acknowledge that We are responsible
          for any User Contributions You submit or contribute, and You, not Us, have full responsibility for such
          content, including its legality, reliability, accuracy, and appropriateness. We are not responsible or liable
          to any third party for the content or accuracy of any User Contributions posted by You or any other User of
          the Services.
        </span>
      </p>
      <p>
        <span>
          <strong>11. Privacy.</strong> We may collect certain personal and non-personal information, cookies, user
          behavioral information, and other data points related to You or Your use of the Site from You
          &#40;&quot;Covered Data&quot;&#41;, through our interactions with You and Your interactions with Our Services.
          The collection and use of the Covered Data are governed according to Our{' '}
          <Link href="https://www.availity.com/Privacy-Policy" target="_blank" loadApp={false}>
            Privacy Policy.
          </Link>{' '}
          This Agreement and the Privacy Policy is meant to comply with all appliable state and federal data privacy
          laws applicable to jurisdiction&#40;s&#41; in which We conduct business, including, but not limited to, the
          California Consumer Privacy Act, as amended &#40;collectively, the &quot;Privacy Laws&quot;&#41;. Any
          ambiguity in this Agreement and / or the Privacy Policy will be resolved in favor of a meaning that permits Us
          to comply with applicable Privacy Laws. We may update the Privacy Policy from time to time and encourage You
          to review the Privacy Policy frequently. You also hereby permit Us to aggregate and de-identify Your Covered
          Data with other information that We have collected from other users so that You may no longer be able to be
          reasonably identified. We are the sole and exclusive owner of any and all proprietary rights in such
          de-identified and aggregated Covered Data and We may use and disclose it for any purpose.
        </span>
      </p>
      <p>
        You also acknowledge that Your use of the Site may require the collection and sharing Covered Data for security,
        user authentication and validation, and compliance with applicable laws, including HIPAA. By using the Site, You
        agree that the Covered Data is necessary to use the Site and cannot be deleted due to the obligations We have to
        maintain the security and integrity of the Site and / or applicable laws. You further acknowledge that the
        Covered Data may be used to improve the Site services and shared with health plans and payers in compliance with
        HIPAA.
      </p>
      <p>
        <span>
          <strong>12. General Disclaimers.</strong> THE SERVICES AND SITE ARE PROVIDED TO YOU ON AN &quot;AS IS, WITH
          ALL FAULTS&quot; BASIS, AND YOUR USE OF THE SERVICES AND SITE IS AT YOUR OWN RISK. THE SITE AND THE CONTENT
          ARE MADE AVAILABLE TO YOU FOR YOUR CONVENIENCE. WE MAKE NO WARRANTIES, WHETHER EXPRESS, IMPLIED, OR STATUTORY,
          REGARDING THE SERVICES, CONTENT, OR ANY UPDATES OR UPGRADES THERETO, OR THE ACCURACY, RELIABILITY, OR
          COMPLETENESS OF ANY CONTENT OR OTHER INFORMATION PROVIDED TO YOU IN CONNECTION WITH THE SERVICES PROVIDED TO
          YOU UNDER THIS AGREEMENT. WE EXPRESSLY AND SPECIFICALLY DISCLAIM ALL IMPLIED WARRANTIES OF MERCHANTABILITY,
          FITNESS FOR A PARTICULAR PURPOSE, RESULTS, WORKMANLIKE EFFORT, COURSE OF DEALING AND TITLE, AND
          NONINFRINGEMENT WITH RESPECT TO THE SERVICES, CONTENT, AND ANY OTHER MATERIALS AND SERVICES, AND WITH RESPECT
          TO THE USE OF ANY OF THE FOREGOING. WE MAKE NO WARRANTY, AND EXPRESSLY DISCLAIMS ANY OBLIGATION, THAT:
          &#40;A&#41; THE SERVICES OR ANY CONTENT, INCLUDING THIRD PARTY CONTENT, CONTAINED THEREIN WILL MEET YOUR
          REQUIREMENTS OR WILL BE AVAILABLE ON AN UNINTERRUPTED, TIMELY, SECURE, OR ERROR-FREE OR VIRUS-FREE BASIS;
          &#40;B&#41; THE CONTENT, FORMS AND INFORMATION PROVIDED ON OR THROUGH THE SERVICES WILL BE UP-TO-DATE,
          COMPLETE, COMPREHENSIVE, OR ACCURATE; &#40;C&#41; THE INFORMATION THAT MAY BE OBTAINED FROM THE USE OF THE
          SERVICES WILL BE ACCURATE OR RELIABLE; &#40;D&#41; THE QUALITY OF THE SERVICES, CONTENT, OR OTHER INFORMATION
          OR MATERIALS OBTAINED BY YOU THROUGH THE SERVICES WILL MEET YOUR EXPECTATIONS; OR &#40;E&#41; THAT DEFECTS, IF
          ANY, WILL BE CORRECTED. YOUR SOLE AND EXCLUSIVE REMEDY FOR ANY TRANSACTION THAT WE FAIL TO TRANSMIT, OR SEND
          IN AN INCORRECT OR INCOMPLETE FORMAT, WILL BE, UPON YOUR WRITTEN REQUEST IF RECEIVED BY US WITHIN THIRTY
          &#40;30&#41; BUSINESS DAYS AFTER SUCH TRANSACTION WAS ORIGINALLY SENT, TO REPROCESS AND/OR RESUBMIT SUCH
          TRANSACTION AT OUR EXPENSE. WE WILL NOT BE RESPONSIBLE FOR ANY DOWN TIME OR SUSPENSION OF YOUR SYSTEM, ANY
          DEFECTIVE PROCESSING, OR FOR THE SECURITY OF DATA DURING TRANSMISSION THROUGH PUBLIC TELECOMMUNICATION LINES.
        </span>
      </p>
      <p>
        Links to other third-party websites may be provided from or through the Site or the Services. When You click on
        these links You will leave Our website and will be redirected to a third party&apos;s website. Third party
        websites are not under Our control. WE ARE NOT RESPONSIBLE OR LIABLE FOR THE CONTENT, SECURITY, OR ANY OTHER
        ASPECT OF THE THIRD-PARTY WEBSITES, OR THE ACTS OR OMISSIONS OF THE APPLICABLE THIRD PARTY, IN ANY WAY.
      </p>
      <p>
        <span>
          <strong>13. Limitation of Liability.</strong> TO THE EXTENT NOT PROHIBITED BY LAW, IN NO EVENT WILL WE, OUR
          AFFILIATES, DIRECTORS, OFFICERS, EMPLOYEES, AGENTS, CONTRACTORS, LICENSORS, SUPPLIERS, SUCCESSORS AND ASSIGNS
          OF EACH, BE LIABLE TO YOU OR ANY OTHER PARTY FOR ANY PERSONAL INJURY OR ANY DIRECT, INDIRECT, SPECIAL,
          PUNITIVE, INCIDENTAL, CONSEQUENTIAL, OR OTHER DAMAGES ARISING OUT OF ANY USE OF THE SERVICES AND/OR CONTENT,
          THE SITE, OR ANY OTHER HYPER-LINKED SITE, INCLUDING BUT NOT LIMITED TO THIRD PARTY WEBSITES. THIS INCLUDES,
          WITHOUT LIMITATION, ANY LOST PROFITS, BUSINESS INTERRUPTION, LOSS OF PROGRAMS OR DATA ON YOUR EQUIPMENT, OR
          OTHER DAMAGES OF ANY NATURE, EVEN IF WE ARE EXPRESSLY ADVISED OF THE POSSIBILITY OR LIKELIHOOD OF SUCH
          DAMAGES. WE SPECIFICALLY DISCLAIM ALL LIABILITY WITH RESPECT TO YOUR ACCESS AND USE OF ANY PHI AND ANY CLAIM
          BETWEEN YOU AND ANY PATIENT OR OTHER THIRD PARTY WITH RESPECT THERETO. ANY CAUSE OF ACTION OR CLAIM YOU MAY
          HAVE ARISING OUT OF OR RELATING TO THIS AGREEMENT OR THE SERVICES MUST BE COMMENCED WITHIN ONE YEAR AFTER THE
          CAUSE OF ACTION ACCRUES; OTHERWISE, SUCH CAUSE OF ACTION OR CLAIM IS PERMANENTLY BARRED. THE EXCLUSIONS AND
          LIMITATIONS OF DAMAGES SET FORTH ABOVE ARE FUNDAMENTAL ELEMENTS OF THE BASIS OF THE AGREEMENT BETWEEN US AND
          YOU.
        </span>
      </p>
      <p>
        <span>
          <strong>14. Term and Termination.</strong> You may use the Services for so long as You possess valid Login
          Credentials, or unless otherwise terminated by Us. We may terminate or suspend Your access to the Services at
          any time, with or without cause. We may deny Your access to the Services in the event You breach this
          Agreement or at any time with or without notice to You. Your rights under this Agreement will terminate
          automatically if You fail to comply with any of its terms.
        </span>
      </p>
      <p>
        <span>
          <strong>15. Third Party Software and Content.</strong> You agree to use any third-party software or content We
          may provide to You solely for the purposes of using the Services in accordance with the terms of this
          Agreement. You acknowledge and agree that We are not responsible for any third-party software or content,
          including its accuracy, completeness, timeliness, validity, copyright compliance, legality, decency, quality
          or any other aspect thereof. We do not assume and will not have any liability or responsibility to You or any
          other person or entity for any third-party software or content. Third-party software and content and links
          thereto are provided solely as a convenience to You, and You access and use them at entirely at Your own risk
          and subject to the terms and conditions of any licenses relating to such third-party software. We may, but
          have no obligation to, assist in the installation of such software. Upon Our request, You will return all
          copies of such third-party software to Us and remove, and certify to Us such removal, of any electronic copies
          of such third-party software stored or residing on Your systems.
        </span>
      </p>
      <p>
        <span>
          <strong>16. Governing Law; Venue; Arbitration.</strong> This Agreement is governed by the laws of the State of
          Florida, without regard to its conflicts of law provisions. Any dispute relating to this Agreement, the Site,
          or the Services will be brought only in a federal or state court sitting in Duval County, Florida. At Our sole
          and absolute discretion, You may be required to submit any disputes arising from this Agreement or Your use of
          the Services, including disputes arising from or concerning their interpretation, violation, invalidity,
          non-performance, or termination, to final and binding arbitration under the Rules of Arbitration of the
          American Arbitration Association applying Florida law in Duval County, Florida.
        </span>
      </p>
      <p>
        <span>
          <strong>17. Force Majeure.</strong> We are not liable in any way for delays, failure in performance, loss, or
          damage due to any of the following conditions beyond Our control: computer “virus” infections, computer system
          downtime, fire, strike, embargo, explosion, power blackout, earthquake, volcanic action, flood, war, water,
          the elements, labor dispute, civil disturbance, governmental requirement, civil or military authority, acts of
          God, public enemy, inability to secure fuel, inability to secure products, inability to secure transportation,
          or other causes beyond Our reasonable control, whether or not similar to the foregoing. We are not liable in
          any way for delays, failure in performance, loss or damage due to acts or omissions cause by You, Your
          Organization, or other providers, payers, or other third parties.
        </span>
      </p>
      <p>
        <span>
          <strong>18. Miscellaneous.</strong>
        </span>
      </p>
      <ol type="a">
        <li>
          It is understood and agreed that no failure or delay by a Party in exercising any right, power, or privilege
          hereunder will operate as a waiver thereof, nor will any single or partial exercise thereof preclude any other
          or further exercise thereof or the exercise of any other right, power or privilege hereunder.
        </li>
        <li>
          If any provision of this Agreement is held by a court or other tribunal of competent jurisdiction to be
          invalid, illegal, or unenforceable for any reason, such provision will be eliminated or limited to the minimum
          extent such that the remaining provisions of this Agreement will continue in full force and effect.
        </li>
        <li>
          You may not assign or delegate any of Your rights or obligations under this Agreement. Any purported
          assignment or delegation in violation of this Section is null and void. No assignment or delegation relieves
          You of any obligations under this Agreement.
        </li>
        <li>
          All legal notices related to this Agreement must be given in writing to Availity at{' '}
          <a href="mailto:legalnotice@availity.com">legalnotice@availity.com</a>. Any legal notice given by Availity to
          You will be delivered via email to Your Administrator.
        </li>
        <li>
          The relationship between the Parties is that of independent contractors. Nothing contained in this Agreement
          will be construed as creating any agency, partnership, joint venture or other form of joint enterprise,
          employment, or fiduciary relationship between the Parties, and neither Party has authority to contract for or
          bind the other Party in any manner whatsoever.
        </li>
        <li>
          Except as otherwise expressly stated otherwise, this Agreement is for the sole benefit of the Parties hereto
          and their respective successors and permitted assigns and nothing herein, express or implied, is intended to
          or will confer upon any other person or entity any legal or equitable right, benefit or remedy of any nature
          whatsoever under or by reason of this Agreement.
        </li>
        <li>
          Provisions of this Agreement, which by their nature should apply beyond their terms, will remain in force
          after any termination or expiration of this Agreement.
        </li>
        <li>
          This Agreement may be amended or modified from time to time in Our sole and absolute discretion by posting
          amendments or modifications to this Agreement to Our Site.
        </li>
        <li>
          This Agreement, including all exhibits and other terms referenced and incorporated herein constitute the sole
          and entire agreement between You and Us regarding the Services and supersede all prior and contemporaneous
          understandings, agreements, representations, and warranties, both written and oral, regarding the Services.
        </li>
      </ol>
    </Typography>
  </Box>
);

export default EssentialsUserAgreement;
